import { useRef, useState } from "react";
import {
    ResponsiveContainer,
    BarChart,
    XAxis,
    YAxis,
    Bar,
    LabelList,
    ReferenceLine,
    Legend
} from "recharts";
import {
  Whisper,
  Tooltip,
} from "rsuite";
import { numberFormatter } from "../../utils";

const PotentialVsActualSales = (props: any) => {

    const {data}=props
    const [tooltip, setTooltip] = useState<any>({ district: "", show: false, costPercent: 0, l4Category: "" })
    
    const renderCustomizedLabel = (props: any) => {
        const { x, y, width, values, height } = props;
        return (
            <>
                {values?.category?.length > 0 && width > 180 && (
                    <text
                        x={x + width / 2}
                        y={y - (values.category.length > 0 ? -(height - 10) : -(height - 10))}
                        fill="#fff"
                        textAnchor="middle"
                        dominantBaseline="middle"
                        className={values.category.length > 15 && width < 180 || values.category.length > 30 && width < 400 ? 'text-[1.2vh] text-wrap' : 'text-[1.5vh] text-wrap'}
                    >
                        {values.category}
                    </text>
                )}
            </>
        );
    };

    const onHover = (data: any, index: number) => {
      console.log(data,'data')
        setTooltip({ show: true, type: data.payload.type, data: data.payload })
    }

    const onOut = () => {
        setTooltip({ show: false, district: "", costPercent: "" });
    }
    console.log(tooltip,123)
    return (
      <>
      
      <table className="common-table-ui" style={{height:'89%'}}>
        <thead>
          <tr>
            <th></th>
            <th></th>
            <th className="text-[1.5vh] px-[1vh]"> Market Share </th>

          </tr>
        </thead>
        <tbody>
          {data?.map((d: any, index: any) => {
            return (
              <tr key={index} className="h-[7vh]">
                 <td className="w-[30%] text-center">
                    {d.type.length > 30 ?
                      <Whisper
                        placement="bottomStart"
                        speaker={
                          <Tooltip>{d.type}</Tooltip>
                        }
                      >
                       { d.type.substring(0, 30) + "..." }

                      </Whisper>
                     : d.type }
                </td>
                <td className=" h-full flex w-full" style={{height:'100%'}}>
                  <ResponsiveContainer
                    width={`${(d?.sales / data[0]?.sales) * 100 < 20 ? ((d?.sales / data[0]?.sales) * 100 )+ 3 : (d?.sales / data[0]?.sales) * 100 }%`}
                    height="100%"
                    minHeight={"7vh"}
                  >
                    <BarChart data={[d]} layout="vertical" stackOffset="expand">
                      <XAxis hide type="number" />
                      <YAxis hide type="category" dataKey="type" />
                      
                      <Bar
                            key={'gbSales'}
                            dataKey={'gbSales'}
                            stackId="a"
                            barSize={15}
                            onMouseEnter={(a: any, index) =>
                              onHover(a.tooltipPayload[0], index)
                            }
                            onMouseLeave={onOut}
                            fill={'#F58427'}
                          >
                          </Bar>
                      <Bar
                            key={'sales'}
                            dataKey={'sales'}
                            stackId="a"
                            onMouseEnter={(a: any, index) =>
                              onHover(a.tooltipPayload[0], index)
                            }
                            onMouseLeave={onOut}
                            fill={'#006400'}
                          >
                          </Bar>
                          
                      {/* {< ReferenceLine x={0.8} isFront={true} strokeWidth={3} label={index % 5 == 0 && { position: 'top', fill: '#a4f504', value: "80% Spend", fontStyle: 'italic' }}></ReferenceLine>} */}
                    </BarChart>
                  </ResponsiveContainer>
                  {/* <span>{numberFormatter(d.netcost, 2)}</span> */}
                  {tooltip.show && tooltip.type == d.type && (
                   
                    <div
											style={{
												position: "absolute",
												bottom: "30vh",
												left: '22.5vw',
												zIndex: 999,
												width: "fit-content",
												background: "white",
												border: "1px solid #ccc",
												boxShadow:
													"0 2px 5px rgba(0,0,0,0.2)",
												borderRadius: "1vh",
												cursor: "pointer",
												color: "black",
												opacity: 0.97,
											}}
										>
											{/* Header Row */}
											<div className="w-full flex justify-start h-[3vh] items-center bg-[#f0f4f8] py-[3vh] px-[1vh] textSmall">
												<div className="font-bold uppercase">
													{tooltip?.type}
												</div>
												<div
													className="font-bold ml-1"
													style={{ color: "#3f3f3f" }}
												>
													
												</div>
											</div>
											{/* Data Row */}
											<div className="h-fit p-[1vh] mt-[.5vh] mb-[.5vh]">
												<p
													className="label"
													style={{
														padding: "0",
														margin: "0",
													}}
												>
													<label
														className="graph-label-small"
														style={{
															color: "#5a5a5a",
															fontWeight:
																"normal",
														}}
													>
														Total Potential:{" "}
													</label>
													<label
														className="graph-label-small"
														style={{
															color: "#3f3f3f",
															fontWeight: "bold",
														}}
													>
														{numberFormatter(tooltip.data?.sales, 2,'$')}
													</label>
												</p>
												<p
													className="label"
													style={{
														padding: "0",
														margin: "0",
													}}
												>
													<label
														className="graph-label-small"
														style={{
															color: "#5a5a5a",
															fontWeight:
																"normal",
														}}
													>
														Actual GB Sales:{" "}
													</label>
													<label
														className="graph-label-small"
														style={{
															color: "#3f3f3f",
															fontWeight: "bold",
														}}
													>
														{numberFormatter(tooltip.data?.gbSales, 2,'$')}
													</label>
												</p>
                        	<p
													className="label"
													style={{
														padding: "0",
														margin: "0",
													}}
												>
													<label
														className="graph-label-small"
														style={{
															color: "#5a5a5a",
															fontWeight:
																"normal",
														}}
													>
														Percentage MS:{" "}
													</label>
													<label
														className="graph-label-small"
														style={{
															color: "#3f3f3f",
															fontWeight: "bold",
														}}
													>
														 {numberFormatter((tooltip.data?.gbDstShare*100), 2)}%
													</label>
												</p>
											</div>
										</div>
                  )}
                </td>
                <td className="text-center">{(d?.gbDstShare*100)?.toFixed(2)}%</td>
              </tr>
            );
          })}
        </tbody>
       
      </table>
        <div className="contentFooter !justify-between">
				  <CustomLegend></CustomLegend>
        </div>
      </>
    );
}

const CustomLegend = () => (
	<div
		style={{
			display: "flex",
			gap: "1rem",
			alignItems: "center",
			color: "black",
			fontSize: "0.8rem",
		}}
	>
		<span>
			<span
				style={{
					display: "inline-block",
					width: 10,
					height: 18,
					background: "#F58427",
					marginRight: 8,
					verticalAlign: "middle",
				}}
			/>
			GB Sales
		</span>
    <span>
			<span
				style={{
					display: "inline-block",
					width: 10,
					height: 18,
					background: "#006400",
					marginRight: 8,
					verticalAlign: "middle",
				}}
			/>
			Potential Sales
		</span>
	</div>
);

export default PotentialVsActualSales;